import { useNavigate } from "react-router-dom";

const Community: React.FC = () => {
    const navigate = useNavigate();
    
    function openLetsTalk(): void {
        navigate('/letstalk')
    }

    return (
        <>
        <section>
                <picture data-position="absolute" data-top="0" data-left="0" data-index="-1" data-mask="">
                    <img src="./images/S9.png" alt="" />
                </picture>
                <group data-direction="column">
                    <space data-height="80" data-adaptive="desktop"></space>
                    <space data-height="80" data-adaptive="mobile"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper data-align="center">
                            <group className="article" data-margin="auto" data-direction="column" data-gap="50"
                                data-align="center">
                                <text data-wrap="wrap" data-weight="600" data-type="group" className="title"
                                    data-direction="column" data-text-size="xxx-large" data-align="center">
                                    <text data-wrap="wrap">Gathering Of The Month</text>
                                </text>
                                <group data-direction="column">
                                    <space data-height="90"></space>
                                    <group data-justify="center" data-gap="40">
                                        <group className="item" data-min-height="350" data-space="30" data-length="forcefit"
                                            data-max-length="350" data-space-vertical="30" data-elevation="7"
                                            data-radius="10" data-backdrop="" data-justify="center" data-gap="40">
                                            <group data-direction="column" data-gap="30" data-align="center"
                                                data-justify="center">
                                                <group data-ratio="16:9" data-background="grey-color-light" data-radius="5" data-contain=""
                                                    data-border="outline">
                                                    <iframe width="100%"
                                                        src="https://www.youtube.com/embed/ClMn1xzXF4s?si=3XkJg3Ce2F2fJLBS"
                                                        title="YouTube video player"
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen>
                                                    </iframe>
                                                </group>
                                                <text className="list_title" data-wrap="wrap" data-weight="700"
                                                    data-type="group" data-direction="column">
                                                    <text data-wrap="wrap" data-text-size="large"
                                                        data-text-align="center">Lifestyle Medicine and
                                                        Innovation</text>
                                                </text>
                                            </group>
                                        </group>
                                        <group className="item" data-min-height="350" data-space="30" data-length="forcefit"
                                            data-max-length="350" data-space-vertical="30" data-elevation="7"
                                            data-radius="10" data-backdrop="" data-justify="center" data-gap="40">
                                            <group data-direction="column" data-gap="30" data-align="center"
                                                data-justify="center">
                                                <group data-ratio="16:9" data-background="grey-color-light" data-radius="5" data-contain=""
                                                    data-border="outline">
                                                    <iframe width="100%"
                                                        src="https://www.youtube.com/embed/dmx3xED_6Vw?si=dO-o65o_eTmPvFyI" 
                                                        title="YouTube video player"
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen
                                                        >
                                                    </iframe>
                                                </group>
                                                <text className="list_title" data-wrap="wrap" data-weight="700"
                                                    data-type="group" data-direction="column">
                                                    <text data-wrap="wrap" data-text-size="large"
                                                        data-text-align="center">Post-Covid Mental Health</text>
                                                </text>
                                            </group>
                                        </group>
                                        <group className="item" data-min-height="350" data-space="30" data-length="forcefit"
                                            data-max-length="350" data-space-vertical="30" data-elevation="7"
                                            data-radius="10" data-backdrop="" data-justify="center" data-gap="40">
                                            <group data-direction="column" data-gap="30" data-align="center"
                                                data-justify="center">
                                                <group data-ratio="16:9" data-background="grey-color-light" data-radius="5" data-contain=""
                                                    data-border="outline">
                                                    <iframe width="100%"
                                                        src="https://www.youtube.com/embed/ix_nxzWkvZE?si=q-3sF0xhNkKVjIXS" 
                                                        title="YouTube video player" frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen>
                                                    </iframe>
                                                </group>
                                                <text className="list_title" data-wrap="wrap" data-weight="700"
                                                    data-type="group" data-direction="column">
                                                    <text data-wrap="wrap" data-text-size="large"
                                                        data-text-align="center">Women's Health</text>
                                                </text>
                                            </group>
                                        </group>
                                    </group>
                                    <space data-height="90"></space>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    
                </group>

            </section>

            <section>
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper data-align="center">
                            <group className="article" data-margin="auto" data-direction="column" data-gap="0"
                                data-max-length="1100" data-align="center">
                                <text data-wrap="wrap" data-weight="600" data-type="group" className="title"
                                    data-direction="column" data-text-size="xxx-large" data-align="center">
                                    <text data-wrap="wrap" data-color="main">Coming Up Soon</text>
                                </text>
                                <text className="description" data-wrap="wrap" data-line="2" data-space-vertical="30"
                                    data-max-length="700" data-color="main"> Live Sessions, Peer Matching, Community Events and much more.</text>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>
        </>
    );
};
export default Community;